import React, { useMemo } from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Box } from '@mui/material';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faDiscord, faInstagram, faXTwitter } from '@fortawesome/free-brands-svg-icons';

import styles from './style';

const YEAR = new Date().getFullYear();

// Bottom of the side menu: the networks to join, the legal links, then the copyright alone at the end.
const SideNavFooter: React.FC = React.memo(() => {
  const { t, i18n } = useTranslation();

  // Same rule as the footer of the public pages: French Discord for French users.
  const discordLink = useMemo(() => {
    if (i18n.language === 'fr') {
      return 'https://discord.gg/T9xb6XTUYg';
    }
    return 'https://discord.gg/EwSjne8D4r';
  }, [i18n.language]);

  return (
    <Box sx={styles.root}>
      <Box sx={styles.socials}>
        <Box component="a" href={discordLink} target="_blank" rel="noreferrer" aria-label="Discord" sx={styles.social}>
          <FontAwesomeIcon icon={faDiscord} />
        </Box>
        <Box component="a" href="https://x.com/soskills_42" target="_blank" rel="noreferrer" aria-label="X" sx={styles.social}>
          <FontAwesomeIcon icon={faXTwitter} />
        </Box>
        <Box component="a" href="https://www.instagram.com/soskills_france" target="_blank" rel="noreferrer" aria-label="Instagram" sx={styles.social}>
          <FontAwesomeIcon icon={faInstagram} />
        </Box>
      </Box>
      <Box component="p" sx={styles.legal}>
        <Box component={Link} to="/contact" sx={styles.link}>{t('contactUs')}</Box>
        <Box component="span" sx={styles.sep}>·</Box>
        <Box component={Link} to="/terms" sx={styles.link}>{t('cgu')}</Box>
        <Box component="span" sx={styles.sep}>·</Box>
        <Box component={Link} to="/privacy" sx={styles.link}>{t('admin.nav.privacy')}</Box>
      </Box>
      <Box component="p" sx={styles.copy}>{`© ${YEAR} SoSkills`}</Box>
    </Box>
  );
});

export default SideNavFooter;
